module.exports = __webpack_public_path__ + "static/media/plus.25c2146b.png";